// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ExploreSvg from '@rsuite/icon-font/lib/application/Explore';
var Explore = createSvgIcon({
  as: ExploreSvg,
  ariaLabel: 'explore',
  category: 'application',
  displayName: 'Explore'
});
export default Explore;